export function createPrescriptionSectionRenderers(ctx) {
  const {
    SectionPrintIndicator,
    // runtime / state
    emrSectionsToShowInOrder,
    nextVisitInputValue,
    setNextVisitInputValue,
    nextVisitInputType,
    setNextVisitInputType,
    mentorProfileData,
    roomId,
    patientId,
    clinicId,
    clinicBrandId,
    getProcessAndSetEventData,
    showNextVisitSlotSelector,
    savePrescriptionData,
    keepSectionStateBeforeClearAll,
    undoClearAllChangeInPrescription,
    printSettings,
    prescriptionData,
    prescriptionViewSettings,
    vitalsRef,
    emrSectionsEditorDialogHandleOpen,
    bookedEventInfo,
    allVitalsOfThisPatient,
    setAllVitalsOfThisPatient,
    selectedObservations,
    setSelectedObservations,
    recommendedHealthEntityForDoctor,
    selectedComplaints,
    setSelectedComplaints,
    selectedDiagnosis,
    setSelectedDiagnosis,
    jointHomunculusData,
    setJointHomunculusData,
    drugsAdvice,
    setDrugsAdvice,
    drugAdviceTypes,
    drugAdviceDosages,
    drugAdviceWhatTimeOptions,
    drugAdviceFrequencies,
    drugAdviceDurations,
    drugAdviceNotes,
    handleAddDrugAdviceItem,
    handleDrugAdviceChange,
    handleDeleteDrugAdviceItem,
    selectedInvestigations,
    setSelectedInvestigations,
    openInvestigationForm,
    showInvestigationForm,
    closeInvestigationForm,
    submitInvestigation,
    initialInvestigationObjectToEdit,
    investigationToEdit,
    setInvestigationToEdit,
    setSavingInvestigation,
    handleChangeInvestigationToEdit,
    investigationTitleValid,
    setInvestigationTitleValid,
    sampleTypes,
    savingInvestigation,
    selectedAdvice,
    setSelectedAdvice,
    selectedInstructions,
    setSelectedInstructions,
    ensureEmptyRowsForTables,
    referredToDoctorName,
    setReferredToDoctorName,
    choseToGiveDiscount,
    discountedPriceOfSession,
    setChoseToGiveDiscount,
    setDiscountedPriceOfSession,
    updateFinalPrice,
    priceUpdateLoading,
    finalRequestedTestsBy,
    setFinalRequestedTestsBy,
    newTestAnchor,
    setNewTestAnchor,
    categoriesListFromStore,
    notesRef,
    selectedTherapies,
    setSelectedTherapies,
    attachPrescriptionForTherapy,
    setAttachPrescriptionForTherapy,
    suggestedBookingTherapy,
    notesToTherapist,
    setNotesToTherapist,
    selectedAssessments,
    setSelectedAssessments,
    attachPrescriptionForAssessments,
    setAttachPrescriptionForAssessments,
    notesForAssessments,
    setNotesForAssessments,
    renderSectionForDocon,
    // constants
    HE_KEY_OBSERVATIONS,
    HE_KEY_HEALTH_COMPLAINTS,
    HE_KEY_DIAGNOSIS,
    HE_KEY_INVESTIGATION,
    HE_KEY_ADVICE,
    HE_KEY_INSTRUCTIONS,
    // components / utilities in JSX
    Card,
    CardContent,
    Box,
    Typography,
    FormControlLabel,
    Checkbox,
    TextareaAutosize,
    CalendarToday,
    Assignment,
    Warning,
    Healing,
    LocalPharmacy,
    Science,
    TipsAndUpdates,
    MenuBook,
    BadgeIcon,
    Psychology,
    AttachMoney,
    CircularProgress,
    Popover,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Button,
    SignatureComponent,
    VitalsComponentInlineEntryComponent,
    ObservationsInputComponent,
    HealthComplaintsInputComponent,
    DiagnosisSelectMenu,
    JointHomunculusComponent,
    DrugAdviceInput,
    InvestigationsSelectMenu,
    AdviceInputComponent,
    EMRInstructionsInput,
    PrivateNotesSection,
    SuggestedTherapySelectMenu,
    SuggestedAssessmentsSelectMenu,
    EMRNextVisitComponent,
    CancelAndRedoComponent,
    AddNewTestComponent,
    InvestigationForm,
    getPriceStringWithCurrency,
    convertAssessmentIdBasedCategoryListToMetaCategoryList,
    isHomunculusValid,
    PMPSectionInputBox,
    DoconPageItemsContainer,
    DoconPageSingleItemContainer,
  } = ctx

    function nextVisitDetailsSection(bookedEventInfo) {
      const section = emrSectionsToShowInOrder?.find((item) => item?.id === 'next_visit_details')
      const hasNextVisitData = nextVisitInputValue && nextVisitInputValue > 0
      
      return (
        <Card
          sx={{
            mb: 3,
            maxWidth: '1200px',
            width: '100%',
            background: 'linear-gradient(135deg, rgba(250, 250, 255, 0.98) 0%, rgba(255, 255, 255, 0.98) 100%)',
            border: '1px solid rgba(67, 56, 202, 0.12)',
            borderRadius: '16px',
            boxShadow: '0 4px 20px rgba(67, 56, 202, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05)',
            overflow: 'visible',
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '4px',
              background: 'linear-gradient(90deg, rgba(67, 56, 202, 0.8) 0%, rgba(99, 102, 241, 0.8) 100%)',
              borderRadius: '16px 16px 0 0',
            },
          }}
          className={section?.printable ? '' : 'hide-on-print'}
        >
          <CardContent sx={{ p: { xs: 2, sm: 2.5, md: 3 } }}>
            {/* Header Section */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: { xs: 2, md: 2.5 },
                pb: 2,
                borderBottom: '2px solid rgba(67, 56, 202, 0.1)',
                flexWrap: { xs: 'wrap', sm: 'nowrap' },
                gap: { xs: 1.5, sm: 2 },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box
                  sx={{
                    width: { xs: '36px', md: '40px' },
                    height: { xs: '36px', md: '40px' },
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'linear-gradient(135deg, rgba(67, 56, 202, 0.15) 0%, rgba(99, 102, 241, 0.15) 100%)',
                    color: '#4338ca',
                    flexShrink: 0,
                  }}
                >
                  <CalendarToday sx={{ fontSize: { xs: 20, md: 22 } }} />
                </Box>
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      color: '#1e293b',
                      fontSize: { xs: '18px', md: '20px' },
                      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                      letterSpacing: '-0.01em',
                      mb: 0.5,
                    }}
                  >
                    Next Visit
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      color: '#64748b',
                      fontSize: '12px',
                      fontStyle: 'italic',
                      display: { xs: 'none', sm: 'block' },
                    }}
                  >
                    Schedule patient&apos;s next appointment
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <CancelAndRedoComponent
                  showCancel={hasNextVisitData}
                  cancelClickFunction={() => {
                    keepSectionStateBeforeClearAll('next_visit_details', {
                      nextVisitInputValue,
                      nextVisitInputType,
                    })
                    setNextVisitInputValue('')
                    setNextVisitInputType('days')
                  }}
                  redoClickFunction={() =>
                    undoClearAllChangeInPrescription('next_visit_details', (data) => {
                      if (data?.nextVisitInputValue !== undefined) {
                        setNextVisitInputValue(data.nextVisitInputValue)
                      }
                      if (data?.nextVisitInputType) {
                        setNextVisitInputType(data.nextVisitInputType)
                      }
                    })
                  }
                />
                <SectionPrintIndicator 
                  sectionId="next_visit_details" 
                  emrSectionsToShowInOrder={emrSectionsToShowInOrder}
                />
              </Box>
            </Box>

            {/* Next Visit Content */}
            <EMRNextVisitComponent
              nextVisitInputValue={nextVisitInputValue}
              setNextVisitInputValue={setNextVisitInputValue}
              nextVisitInputType={nextVisitInputType}
              setNextVisitInputType={setNextVisitInputType}
              bookedEventInfoStartTime={bookedEventInfo?.startTime}
              mentorProfileData={mentorProfileData}
              roomId={bookedEventInfo?.chamberRoomId || roomId}
              currentEventTypeId={bookedEventInfo?.eventTypeId}
              currentPatient={{
                id: patientId,
                name: bookedEventInfo?.userName,
                clinicId: clinicId,
                clinicBrandId: clinicBrandId,
              }}
              refreshCurrentBookedEventInfoData={async () => getProcessAndSetEventData(false)}
              currentFee={bookedEventInfo?.fee}
              currentBookedEventId={bookedEventInfo?.id}
              currentFeePaid={bookedEventInfo?.feePaid}
              nextVisitBookedEventId={bookedEventInfo?.nextVisitReferenceBookedEventId}
              showHoldSlotForNextVisit={showNextVisitSlotSelector}
              saveReport={savePrescriptionData}
            />
          </CardContent>
        </Card>
      )
    }

    function renderSignatureSection() {
      const section = emrSectionsToShowInOrder?.find((item) => item?.id === 'signature')
      const signatureImageId =
        section?.signatureImageId ?? section?.properties?.signatureImageId ?? section?.signature
        ?? printSettings?.selectedPrescriptionTemplate?.signature ?? prescriptionData?.signature
      const doctorName =
        section?.doctorName ?? section?.properties?.doctorName
        ?? printSettings?.selectedPrescriptionTemplate?.doctorName ?? prescriptionData?.doctorName ?? ''
      return (
        <Card
          sx={{
            mb: 3,
            maxWidth: '1200px',
            width: '100%',
            background: 'linear-gradient(135deg, rgba(250, 250, 255, 0.98) 0%, rgba(255, 255, 255, 0.98) 100%)',
            border: '1px solid rgba(67, 56, 202, 0.12)',
            borderRadius: '16px',
            boxShadow: '0 4px 20px rgba(67, 56, 202, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05)',
            overflow: 'visible',
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '4px',
              background: 'linear-gradient(90deg, rgba(67, 56, 202, 0.8) 0%, rgba(99, 102, 241, 0.8) 100%',
              borderRadius: '16px 16px 0 0',
            },
          }}
          className={section?.printable ? '' : 'hide-on-print'}
        >
          <CardContent sx={{ p: { xs: 2, sm: 2.5, md: 3 } }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
              <Typography variant="h6" sx={{ fontWeight: 700, color: '#1e293b' }}>
                Doctor&apos;s Signature
              </Typography>
              <SectionPrintIndicator sectionId="signature" emrSectionsToShowInOrder={emrSectionsToShowInOrder} />
            </Box>
            {signatureImageId ? (
              <SignatureComponent
                signatureSize={section?.properties?.signatureSize ?? prescriptionViewSettings?.paperPrintSettings?.styleOverridesForPrintedEmrSections?.signature?.otherStyles?.signatureSize}
                signatureMediaId={signatureImageId}
                doctorName={doctorName}
              />
            ) : (
              <Typography variant="body2" color="text.secondary">
                Signature is set from your prescription template. Edit template in Settings to change.
              </Typography>
            )}
          </CardContent>
        </Card>
      )
    }

    function renderPatientVitals() {
      const section = emrSectionsToShowInOrder?.find((item) => item?.id === 'patient-vitals')
      return (
        <>
          <VitalsComponentInlineEntryComponent
            ref={vitalsRef}
            patientId={bookedEventInfo?.patientId}
            clinicId={bookedEventInfo?.clinicId}
            isPrintable={section?.printable}
            setIsPrintable={() => emrSectionsEditorDialogHandleOpen()}
            withCreateButton={true}
            bookedEventId={bookedEventInfo?.id}
            existingVitalData={allVitalsOfThisPatient?.find(
              (item) => item?.bookedEventId === bookedEventInfo?.id,
            )}
            locallyChangeExistingVitalData={(newVitalForThisBooking) => {
              setAllVitalsOfThisPatient((prev) => {
                const vitalCopy = prev ? [...prev] : []
                const vitalsArrayWithoutThisBooking = vitalCopy?.filter(
                  (item) => item?.bookedEventId !== bookedEventInfo?.id,
                )
                return [...vitalsArrayWithoutThisBooking, newVitalForThisBooking]
              })
            }}
          />
        </>
      )
    }

    function renderObservations() {
      return (
        <Card
          sx={{
            mb: 3,
            background: 'linear-gradient(135deg, rgba(250, 250, 255, 0.98) 0%, rgba(255, 255, 255, 0.98) 100%)',
            border: '1px solid rgba(67, 56, 202, 0.12)',
            borderRadius: '16px',
            boxShadow: '0 4px 20px rgba(67, 56, 202, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05)',
            overflow: 'visible',
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '4px',
              background: 'linear-gradient(90deg, rgba(67, 56, 202, 0.8) 0%, rgba(99, 102, 241, 0.8) 100%)',
              borderRadius: '16px 16px 0 0',
            },
          }}
          className={
            emrSectionsToShowInOrder?.find((item) => item?.id === 'observations')?.printable
              ? ''
              : 'hide-on-print'
          }
        >
          <CardContent sx={{ p: 3 }}>
            {/* Header Section */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: 2.5,
                pb: 2,
                borderBottom: '2px solid rgba(67, 56, 202, 0.1)',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box
                  sx={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'linear-gradient(135deg, rgba(67, 56, 202, 0.15) 0%, rgba(99, 102, 241, 0.15) 100%)',
                    color: '#4338ca',
                  }}
                >
                  <Assignment sx={{ fontSize: 22 }} />
                </Box>
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      color: '#1e293b',
                      fontSize: '20px',
                      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                      letterSpacing: '-0.01em',
                      mb: 0.5,
                    }}
                  >
                    Observations
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      color: '#64748b',
                      fontSize: '12px',
                      fontStyle: 'italic',
                    }}
                  >
                    Record clinical observations and findings
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <CancelAndRedoComponent
              showCancel={Array.isArray(selectedObservations) && selectedObservations?.length > 0}
              cancelClickFunction={() => {
                keepSectionStateBeforeClearAll('observations', selectedObservations)
                setSelectedObservations([])
              }}
              redoClickFunction={() =>
                undoClearAllChangeInPrescription('observations', (data) =>
                  setSelectedObservations(data),
                )
              }
            />
                <SectionPrintIndicator 
                  sectionId="observations" 
                  emrSectionsToShowInOrder={emrSectionsToShowInOrder}
                />
              </Box>
            </Box>

            {/* Observations Input Section */}
            <Box sx={{ mt: 2 }}>
          <ObservationsInputComponent
            clinicId={clinicId}
            clinicBrandId={clinicBrandId}
            observations={selectedObservations}
            setSelectedObservations={setSelectedObservations}
            prescriptionViewSettings={prescriptionViewSettings}
            recommendedObservations={recommendedHealthEntityForDoctor?.[HE_KEY_OBSERVATIONS]}
          />
            </Box>
          </CardContent>
        </Card>
      )
    }

    function renderHealthComplaints() {
      return (
        <Card
          sx={{
            mb: 3,
            background: 'linear-gradient(135deg, rgba(250, 250, 255, 0.98) 0%, rgba(255, 255, 255, 0.98) 100%)',
            border: '1px solid rgba(67, 56, 202, 0.12)',
            borderRadius: '16px',
            boxShadow: '0 4px 20px rgba(67, 56, 202, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05)',
            overflow: 'visible',
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '4px',
              background: 'linear-gradient(90deg, rgba(67, 56, 202, 0.8) 0%, rgba(99, 102, 241, 0.8) 100%)',
              borderRadius: '16px 16px 0 0',
            },
          }}
          className={
            emrSectionsToShowInOrder?.find((item) => item?.id === 'health_complaints')?.printable
              ? ''
              : 'hide-on-print'
          }
        >
          <CardContent sx={{ p: 3 }}>
            {/* Header Section */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: 2.5,
                pb: 2,
                borderBottom: '2px solid rgba(67, 56, 202, 0.1)',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box
                  sx={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'linear-gradient(135deg, rgba(67, 56, 202, 0.15) 0%, rgba(99, 102, 241, 0.15) 100%)',
                    color: '#4338ca',
                  }}
                >
                  <Warning sx={{ fontSize: 22 }} />
                </Box>
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      color: '#1e293b',
                      fontSize: '20px',
                      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                      letterSpacing: '-0.01em',
                      mb: 0.5,
                    }}
                  >
                    Complaints
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      color: '#64748b',
                      fontSize: '12px',
                      fontStyle: 'italic',
                    }}
                  >
                    Record patient complaints and symptoms
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <CancelAndRedoComponent
              showCancel={Array.isArray(selectedComplaints) && selectedComplaints?.length > 0}
              cancelClickFunction={() => {
                keepSectionStateBeforeClearAll('health_complaints', selectedComplaints)
                setSelectedComplaints([])
              }}
              redoClickFunction={() =>
                undoClearAllChangeInPrescription('health_complaints', (data) =>
                  setSelectedComplaints(data),
                )
              }
            />
                <SectionPrintIndicator 
                  sectionId="health_complaints" 
                  emrSectionsToShowInOrder={emrSectionsToShowInOrder}
                />
              </Box>
            </Box>

            {/* Complaints Input Section */}
            <Box sx={{ mt: 2 }}>
          <HealthComplaintsInputComponent
            clinicId={clinicId}
            clinicBrandId={clinicBrandId}
            selectedComplaints={selectedComplaints}
            setSelectedComplaints={setSelectedComplaints}
            prescriptionViewSettings={prescriptionViewSettings}
            recommendedComplaints={recommendedHealthEntityForDoctor?.[HE_KEY_HEALTH_COMPLAINTS]}
          />
            </Box>
          </CardContent>
        </Card>
      )
    }

    function renderDiagnosis() {
      return (
        <Card
          sx={{
            mb: 3,
            background: 'linear-gradient(135deg, rgba(250, 250, 255, 0.98) 0%, rgba(255, 255, 255, 0.98) 100%)',
            border: '1px solid rgba(67, 56, 202, 0.12)',
            borderRadius: '16px',
            boxShadow: '0 4px 20px rgba(67, 56, 202, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05)',
            overflow: 'visible',
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '4px',
              background: 'linear-gradient(90deg, rgba(67, 56, 202, 0.8) 0%, rgba(99, 102, 241, 0.8) 100%)',
              borderRadius: '16px 16px 0 0',
            },
          }}
          className={
            emrSectionsToShowInOrder?.find((item) => item?.id === 'diagnosis')?.printable
              ? ''
              : 'hide-on-print'
          }
        >
          <CardContent sx={{ p: 3 }}>
            {/* Header Section */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: 2.5,
                pb: 2,
                borderBottom: '2px solid rgba(67, 56, 202, 0.1)',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box
                  sx={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'linear-gradient(135deg, rgba(67, 56, 202, 0.15) 0%, rgba(99, 102, 241, 0.15) 100%)',
                    color: '#4338ca',
                  }}
                >
                  <Healing sx={{ fontSize: 22 }} />
                </Box>
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      color: '#1e293b',
                      fontSize: '20px',
                      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                      letterSpacing: '-0.01em',
                      mb: 0.5,
                    }}
                  >
                    Diagnosis
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      color: '#64748b',
                      fontSize: '12px',
                      fontStyle: 'italic',
                    }}
                  >
                    Record clinical diagnosis and medical conditions
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <CancelAndRedoComponent
              showCancel={Array.isArray(selectedDiagnosis) && selectedDiagnosis?.length > 0}
              cancelClickFunction={() => {
                keepSectionStateBeforeClearAll('diagnosis', selectedDiagnosis)
                setSelectedDiagnosis([])
                window.setTimeout(() => ensureEmptyRowsForTables(), 0)
              }}
              redoClickFunction={() => {
                undoClearAllChangeInPrescription('diagnosis', (data) => setSelectedDiagnosis(data))
                window.setTimeout(() => ensureEmptyRowsForTables(), 0)
              }}
            />
                <SectionPrintIndicator 
                  sectionId="diagnosis" 
                  emrSectionsToShowInOrder={emrSectionsToShowInOrder}
                />
              </Box>
            </Box>

            {/* Diagnosis Input Section */}
            <Box 
              sx={{ 
                mt: 2,
                position: 'relative',
                zIndex: 1000, // Ensure container has proper stacking context
              }}
            >
          <DiagnosisSelectMenu
            clinicId={clinicId}
            clinicBrandId={clinicBrandId}
            selectedDiagnosis={selectedDiagnosis}
            setSelectedDiagnosis={setSelectedDiagnosis}
            prescriptionViewSettings={prescriptionViewSettings}
            recommendedDiagnosis={recommendedHealthEntityForDoctor?.[HE_KEY_DIAGNOSIS]}
            diagnosisSubSections={diagnosisSubSections}
            menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
          />
            </Box>
          </CardContent>
        </Card>
      )
    }

    function renderJointHomunculus() {
      const section = emrSectionsToShowInOrder?.find((item) => item?.id === 'joint_homunculus')
      const hasHomunculusData = isHomunculusValid(jointHomunculusData)
      
      return (
        <Card
          sx={{
            mb: 3,
            maxWidth: '1200px',
            width: '100%',
            background: 'linear-gradient(135deg, rgba(250, 250, 255, 0.98) 0%, rgba(255, 255, 255, 0.98) 100%)',
            border: '1px solid rgba(67, 56, 202, 0.12)',
            borderRadius: '16px',
            boxShadow: '0 4px 20px rgba(67, 56, 202, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05)',
            overflow: 'visible',
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '4px',
              background: 'linear-gradient(90deg, rgba(67, 56, 202, 0.8) 0%, rgba(99, 102, 241, 0.8) 100%)',
              borderRadius: '16px 16px 0 0',
            },
          }}
          className={section?.printable ? '' : 'hide-on-print'}
        >
          <CardContent sx={{ p: { xs: 2, sm: 2.5, md: 3 } }}>
            {/* Header Section */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: { xs: 2, md: 2.5 },
                pb: 2,
                borderBottom: '2px solid rgba(67, 56, 202, 0.1)',
                flexWrap: { xs: 'wrap', sm: 'nowrap' },
                gap: { xs: 1.5, sm: 2 },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box
                  sx={{
                    width: { xs: '36px', md: '40px' },
                    height: { xs: '36px', md: '40px' },
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'linear-gradient(135deg, rgba(67, 56, 202, 0.15) 0%, rgba(99, 102, 241, 0.15) 100%)',
                    color: '#4338ca',
                    flexShrink: 0,
                  }}
                >
                  <Healing sx={{ fontSize: { xs: 20, md: 22 } }} />
                </Box>
                <Box>
                  <Typography
                    variant="h6"
                    component="label"
              htmlFor="join-homunculus-interface-checkbox"
                    sx={{
                      fontWeight: 700,
                      color: '#1e293b',
                      fontSize: { xs: '18px', md: '20px' },
                      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                      letterSpacing: '-0.01em',
                      mb: 0.5,
                      cursor: 'pointer',
                      textDecoration: 'inherit',
                    }}
            >
              44-Joint Homunculus
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      color: '#64748b',
                      fontSize: '12px',
                      fontStyle: 'italic',
                      display: { xs: 'none', sm: 'block' },
                    }}
                  >
                    Mark affected joints on the body diagram
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
              <CancelAndRedoComponent
                  showCancel={hasHomunculusData}
                cancelClickFunction={() => {
                  keepSectionStateBeforeClearAll('joint_homunculus', jointHomunculusData)
                  const updatedData = Object.keys(jointHomunculusData).reduce((acc, key) => {
                    acc[key] = false
                    return acc
                  }, {})
                  setJointHomunculusData(updatedData)
                }}
                redoClickFunction={() =>
                  undoClearAllChangeInPrescription('joint_homunculus', (data) =>
                    setJointHomunculusData(data),
                  )
                }
              />
                <SectionPrintIndicator 
                  sectionId="joint_homunculus" 
                  emrSectionsToShowInOrder={emrSectionsToShowInOrder}
                />
              </Box>
            </Box>

            {/* Joint Homunculus Component */}
            <Box
              sx={{
                mt: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: '10px',
                position: 'relative',
                zIndex: 2,
              }}
            >
            <JointHomunculusComponent
              editable={true}
              data={jointHomunculusData}
              setData={setJointHomunculusData}
            />
            </Box>
          </CardContent>
        </Card>
      )
    }

    const drugAdviceSubSections = emrSectionsToShowInOrder?.find(
      (item) => item?.id === 'drug_advice',
    )?.subSections
    const diagnosisSubSections = emrSectionsToShowInOrder?.find(
      (item) => item?.id === 'diagnosis',
    )?.subSections

    function renderDrugAdvice() {
      return (
        <Card
          sx={{
            mb: 3,
            background: 'linear-gradient(135deg, rgba(250, 250, 255, 0.98) 0%, rgba(255, 255, 255, 0.98) 100%)',
            border: '1px solid rgba(67, 56, 202, 0.12)',
            borderRadius: '16px',
            boxShadow: '0 4px 20px rgba(67, 56, 202, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05)',
            overflow: 'visible',
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '4px',
              background: 'linear-gradient(90deg, rgba(67, 56, 202, 0.8) 0%, rgba(99, 102, 241, 0.8) 100%)',
              borderRadius: '16px 16px 0 0',
            },
          }}
          className={
            emrSectionsToShowInOrder?.find((item) => item?.id === 'drug_advice')?.printable
              ? ''
              : 'hide-on-print'
          }
        >
          <CardContent sx={{ p: { xs: 2, sm: 2.5, md: 3 } }}>
            {/* Header Section */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: { xs: 2, md: 2.5 },
                pb: 2,
                borderBottom: '2px solid rgba(67, 56, 202, 0.1)',
                flexWrap: { xs: 'wrap', sm: 'nowrap' },
                gap: { xs: 1.5, sm: 2 },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box
                  sx={{
                    width: { xs: '36px', md: '40px' },
                    height: { xs: '36px', md: '40px' },
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'linear-gradient(135deg, rgba(67, 56, 202, 0.15) 0%, rgba(99, 102, 241, 0.15) 100%)',
                    color: '#4338ca',
                    flexShrink: 0,
                  }}
                >
                  <LocalPharmacy sx={{ fontSize: { xs: 20, md: 22 } }} />
                </Box>
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      color: '#1e293b',
                      fontSize: { xs: '18px', md: '20px' },
                      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                      letterSpacing: '-0.01em',
                      mb: 0.5,
                    }}
                  >
                    Rx (Prescription)
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      color: '#64748b',
                      fontSize: '12px',
                      fontStyle: 'italic',
                      display: { xs: 'none', sm: 'block' },
                    }}
                  >
                    Prescribe medications and drug advice
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5,
                  flexShrink: 0,
                }}
              >
            <SectionPrintIndicator 
              sectionId="drug_advice" 
              emrSectionsToShowInOrder={emrSectionsToShowInOrder}
            />
              </Box>
            </Box>

            {/* Drug Advice Input Section */}
            <Box
              sx={{
                mt: 2,
                overflowX: { xs: 'auto', md: 'visible' },
                '&::-webkit-scrollbar': {
                  height: '8px',
                },
                '&::-webkit-scrollbar-track': {
                  background: 'rgba(67, 56, 202, 0.05)',
                  borderRadius: '10px',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: 'rgba(67, 56, 202, 0.2)',
                  borderRadius: '10px',
                  '&:hover': {
                    background: 'rgba(67, 56, 202, 0.3)',
                  },
                },
              }}
            >
          <DrugAdviceInput
            clinicBrandId={clinicBrandId}
            clinicId={clinicId}
            drugAdviceTypes={drugAdviceTypes}
            drugAdviceDurations={drugAdviceDurations}
            drugAdviceFrequencies={drugAdviceFrequencies}
            drugAdviceNotes={drugAdviceNotes}
            drugAdviceWhatTimeOptions={drugAdviceWhatTimeOptions}
            drugAdviceDosages={drugAdviceDosages}
            drugsAdvice={drugsAdvice}
            handleAddDrugAdviceItem={handleAddDrugAdviceItem}
            handleDrugAdviceChange={handleDrugAdviceChange}
            handleDeleteDrugAdviceItem={handleDeleteDrugAdviceItem}
            mentorProfileData={mentorProfileData}
            prescriptionViewSettings={prescriptionViewSettings}
            recommendedHealthEntityForDoctor={recommendedHealthEntityForDoctor}
            setDrugsAdvice={setDrugsAdvice}
            drugAdviceSubSections={drugAdviceSubSections}
          />
            </Box>
          </CardContent>
        </Card>
      )
    }

    function renderInvestigations() {
      return (
        <>
        <Card
          sx={{
            mb: 3,
            background: 'linear-gradient(135deg, rgba(250, 250, 255, 0.98) 0%, rgba(255, 255, 255, 0.98) 100%)',
            border: '1px solid rgba(67, 56, 202, 0.12)',
            borderRadius: '16px',
            boxShadow: '0 4px 20px rgba(67, 56, 202, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05)',
            overflow: 'visible',
            position: 'relative',
            zIndex: 1, // Base z-index for card
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '4px',
              background: 'linear-gradient(90deg, rgba(67, 56, 202, 0.8) 0%, rgba(99, 102, 241, 0.8) 100%)',
              borderRadius: '16px 16px 0 0',
            },
          }}
          className={
            emrSectionsToShowInOrder?.find((item) => item?.id === 'investigations')?.printable
              ? ''
              : 'hide-on-print'
          }
        >
          <CardContent sx={{ p: { xs: 2, sm: 2.5, md: 3 } }}>
            {/* Header Section */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: { xs: 2, md: 2.5 },
                pb: 2,
                borderBottom: '2px solid rgba(67, 56, 202, 0.1)',
                flexWrap: { xs: 'wrap', sm: 'nowrap' },
                gap: { xs: 1.5, sm: 2 },
                position: 'relative',
                zIndex: 1, // Header above card but below dropdowns
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box
                  sx={{
                    width: { xs: '36px', md: '40px' },
                    height: { xs: '36px', md: '40px' },
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'linear-gradient(135deg, rgba(67, 56, 202, 0.15) 0%, rgba(99, 102, 241, 0.15) 100%)',
                    color: '#4338ca',
                    flexShrink: 0,
                  }}
                >
                  <Science sx={{ fontSize: { xs: 20, md: 22 } }} />
                </Box>
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      color: '#1e293b',
                      fontSize: { xs: '18px', md: '20px' },
                      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                      letterSpacing: '-0.01em',
                      mb: 0.5,
                    }}
                  >
                    Order Investigations
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      color: '#64748b',
                      fontSize: '12px',
                      fontStyle: 'italic',
                      display: { xs: 'none', sm: 'block' },
                    }}
                  >
                    Order investigations and lab tests
                  </Typography>
                </Box>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5,
                  flexShrink: 0,
                  position: 'relative',
                  zIndex: 1, // Print button above card but below dropdowns
                }}
              >
                <CancelAndRedoComponent
                  showCancel={
                    Array.isArray(selectedInvestigations) && selectedInvestigations?.length > 0
                  }
                  cancelClickFunction={() => {
                    keepSectionStateBeforeClearAll('investigations', selectedInvestigations)
                    setSelectedInvestigations([])
                  }}
                  redoClickFunction={() =>
                    undoClearAllChangeInPrescription('investigations', (data) =>
                      setSelectedInvestigations(data),
                    )
                  }
                />
                <SectionPrintIndicator 
                  sectionId="investigations" 
                  emrSectionsToShowInOrder={emrSectionsToShowInOrder}
                />
              </Box>
            </Box>

            {/* Investigations Input Section */}
            <Box
              sx={{
                mt: 2,
                position: 'relative',
                zIndex: 2, // Content above card and header
              }}
            >
              <InvestigationsSelectMenu
                clinicId={clinicId}
                clinicBrandId={clinicBrandId}
                selectedInvestigations={selectedInvestigations}
                finalRequestedTestsBy={finalRequestedTestsBy}
                setFinalRequestedTestsBy={setFinalRequestedTestsBy}
                setSelectedInvestigations={setSelectedInvestigations}
                onCreateInvestigation={openInvestigationForm}
                prescriptionViewSettings={prescriptionViewSettings}
                recommendedInvestigationIds={
                  recommendedHealthEntityForDoctor?.[HE_KEY_INVESTIGATION]
                }
              />
            </Box>
          </CardContent>
        </Card>

          {/* <ButtonSCNContainer
style={{ marginTop: '8px', fontSize: '12px' }}
onClick={(e) => setNewTestAnchor(e.currentTarget)}
>
Add New
</ButtonSCNContainer> */}

          <Popover
            id="newTestPopover"
            anchorEl={newTestAnchor}
            open={Boolean(newTestAnchor)}
            onClose={() => setNewTestAnchor(null)}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <div>
              <AddNewTestComponent
                clinicId={clinicId}
                clinicBrandId={clinicBrandId}
                closeFunc={() => setNewTestAnchor(null)}
              />
            </div>
          </Popover>
          <Dialog
            open={showInvestigationForm}
            onClose={closeInvestigationForm}
            PaperProps={{
              sx: { maxWidth: '768px !important', width: '100% important' },
            }}
          >
            <DialogTitle>Add Investigation</DialogTitle>
            <DialogContent>
              <form id="investigation-form" onSubmit={submitInvestigation}>
                <InvestigationForm
                  initialObject={initialInvestigationObjectToEdit}
                  investigation={investigationToEdit}
                  setInvestigation={setInvestigationToEdit}
                  setSaving={setSavingInvestigation}
                  handleChangeObject={handleChangeInvestigationToEdit}
                  titleValid={investigationTitleValid}
                  setTitleValid={setInvestigationTitleValid}
                  clinicId={clinicId}
                  clinicBrandId={clinicBrandId}
                  customOptions={{
                    categories:
                      convertAssessmentIdBasedCategoryListToMetaCategoryList(
                        categoriesListFromStore,
                      ),
                    investigationSample: sampleTypes || [],
                  }}
                />
              </form>
            </DialogContent>
            <DialogActions>
              <Button sx={{ color: 'grey' }} onClick={closeInvestigationForm}>
                Close
              </Button>
              <Button
                variant="contained"
                color="success"
                type="submit"
                form="investigation-form"
                disabled={savingInvestigation || !investigationTitleValid}
              >
                Save
              </Button>
            </DialogActions>
          </Dialog>
        </>
      )
    }

    function renderAdvice() {
      const section = emrSectionsToShowInOrder?.find((item) => item?.id === 'advice')
      return (
        <Card
          sx={{
            mb: 3,
            maxWidth: '1200px',
            width: '100%',
            background: 'linear-gradient(135deg, rgba(250, 250, 255, 0.98) 0%, rgba(255, 255, 255, 0.98) 100%)',
            border: '1px solid rgba(67, 56, 202, 0.12)',
            borderRadius: '16px',
            boxShadow: '0 4px 20px rgba(67, 56, 202, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05)',
            overflow: 'visible',
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '4px',
              background: 'linear-gradient(90deg, rgba(67, 56, 202, 0.8) 0%, rgba(99, 102, 241, 0.8) 100%)',
              borderRadius: '16px 16px 0 0',
            },
          }}
          className={section?.printable ? '' : 'hide-on-print'}
        >
          <CardContent sx={{ p: { xs: 2, sm: 2.5, md: 3 } }}>
            {/* Header Section */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: { xs: 2, md: 2.5 },
                pb: 2,
                borderBottom: '2px solid rgba(67, 56, 202, 0.1)',
                flexWrap: { xs: 'wrap', sm: 'nowrap' },
                gap: { xs: 1.5, sm: 2 },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box
                  sx={{
                    width: { xs: '36px', md: '40px' },
                    height: { xs: '36px', md: '40px' },
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'linear-gradient(135deg, rgba(67, 56, 202, 0.15) 0%, rgba(99, 102, 241, 0.15) 100%)',
                    color: '#4338ca',
                    flexShrink: 0,
                  }}
                >
                  <TipsAndUpdates sx={{ fontSize: { xs: 20, md: 22 } }} />
                </Box>
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      color: '#1e293b',
                      fontSize: { xs: '18px', md: '20px' },
                      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                      letterSpacing: '-0.01em',
                      mb: 0.5,
                    }}
                  >
                    Advice
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      color: '#64748b',
                      fontSize: '12px',
                      fontStyle: 'italic',
                      display: { xs: 'none', sm: 'block' },
                    }}
                  >
                    Provide clinical advice and recommendations
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <CancelAndRedoComponent
                  showCancel={Array.isArray(selectedAdvice) && selectedAdvice?.length > 0}
                  cancelClickFunction={() => {
                    keepSectionStateBeforeClearAll('advice', selectedAdvice)
                    setSelectedAdvice([])
                  }}
                  redoClickFunction={() =>
                    undoClearAllChangeInPrescription('advice', (data) => setSelectedAdvice(data))
                  }
                />
                <SectionPrintIndicator 
                  sectionId="advice" 
                  emrSectionsToShowInOrder={emrSectionsToShowInOrder}
                />
              </Box>
            </Box>

            {/* Advice Input Section */}
            <Box
              sx={{
                mt: 2,
                position: 'relative',
                zIndex: 2,
              }}
            >
              <AdviceInputComponent
                clinicId={clinicId}
                clinicBrandId={clinicBrandId}
                advices={selectedAdvice}
                prescriptionViewSettings={prescriptionViewSettings}
                recommendedAdvices={recommendedHealthEntityForDoctor?.[HE_KEY_ADVICE]}
                setAdvices={setSelectedAdvice}
              />
            </Box>
          </CardContent>
        </Card>
      )
    }

    function renderInstructions() {
      const section = emrSectionsToShowInOrder?.find((item) => item?.id === 'instructions')
      return (
        <Card
          sx={{
            mb: 3,
            maxWidth: '1200px',
            width: '100%',
            background: 'linear-gradient(135deg, rgba(250, 250, 255, 0.98) 0%, rgba(255, 255, 255, 0.98) 100%)',
            border: '1px solid rgba(67, 56, 202, 0.12)',
            borderRadius: '16px',
            boxShadow: '0 4px 20px rgba(67, 56, 202, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05)',
            overflow: 'visible',
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '4px',
              background: 'linear-gradient(90deg, rgba(67, 56, 202, 0.8) 0%, rgba(99, 102, 241, 0.8) 100%)',
              borderRadius: '16px 16px 0 0',
            },
          }}
          className={section?.printable ? '' : 'hide-on-print'}
        >
          <CardContent sx={{ p: { xs: 2, sm: 2.5, md: 3 } }}>
            {/* Header Section */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: { xs: 2, md: 2.5 },
                pb: 2,
                borderBottom: '2px solid rgba(67, 56, 202, 0.1)',
                flexWrap: { xs: 'wrap', sm: 'nowrap' },
                gap: { xs: 1.5, sm: 2 },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box
                  sx={{
                    width: { xs: '36px', md: '40px' },
                    height: { xs: '36px', md: '40px' },
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'linear-gradient(135deg, rgba(67, 56, 202, 0.15) 0%, rgba(99, 102, 241, 0.15) 100%)',
                    color: '#4338ca',
                    flexShrink: 0,
                  }}
                >
                  <MenuBook sx={{ fontSize: { xs: 20, md: 22 } }} />
                </Box>
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      color: '#1e293b',
                      fontSize: { xs: '18px', md: '20px' },
                      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                      letterSpacing: '-0.01em',
                      mb: 0.5,
                    }}
                  >
                    Instructions
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      color: '#64748b',
                      fontSize: '12px',
                      fontStyle: 'italic',
                      display: { xs: 'none', sm: 'block' },
                    }}
                  >
                    Provide patient care instructions
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <CancelAndRedoComponent
                  showCancel={
                    Array.isArray(selectedInstructions) && selectedInstructions?.length > 0
                  }
                  cancelClickFunction={() => {
                    keepSectionStateBeforeClearAll('instructions', selectedInstructions)
                    setSelectedInstructions([])
                  }}
                  redoClickFunction={() =>
                    undoClearAllChangeInPrescription('instructions', (data) =>
                      setSelectedInstructions(data),
                    )
                  }
                />
                <SectionPrintIndicator 
                  sectionId="instructions" 
                  emrSectionsToShowInOrder={emrSectionsToShowInOrder}
                />
              </Box>
            </Box>

            {/* Instructions Input Section */}
            <Box
              sx={{
                mt: 2,
                position: 'relative',
                zIndex: 2,
              }}
            >
              <EMRInstructionsInput
                clinicId={clinicId}
                clinicBrandId={clinicBrandId}
                selectedInstructions={selectedInstructions}
                setSelectedInstructions={setSelectedInstructions}
                prescriptionViewSettings={prescriptionViewSettings}
                recommendedInstructionIds={recommendedHealthEntityForDoctor?.[HE_KEY_INSTRUCTIONS]}
              />
            </Box>
          </CardContent>
        </Card>
      )
    }

    function renderPayemntAndRefundSection() {
      const section = emrSectionsToShowInOrder?.find((item) => item?.id === 'payment_and_refund')
      const hasPaymentData = choseToGiveDiscount || Boolean(bookedEventInfo?.discountAction?.discountedPrice)
      
      return (
        <Card
          sx={{
            mb: 3,
            maxWidth: '1200px',
            width: '100%',
            background: 'linear-gradient(135deg, rgba(250, 250, 255, 0.98) 0%, rgba(255, 255, 255, 0.98) 100%)',
            border: '1px solid rgba(67, 56, 202, 0.12)',
            borderRadius: '16px',
            boxShadow: '0 4px 20px rgba(67, 56, 202, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05)',
            overflow: 'visible',
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '4px',
              background: 'linear-gradient(90deg, rgba(67, 56, 202, 0.8) 0%, rgba(99, 102, 241, 0.8) 100%)',
              borderRadius: '16px 16px 0 0',
            },
          }}
          className={section?.printable ? '' : 'hide-on-print'}
        >
          <CardContent sx={{ p: { xs: 2, sm: 2.5, md: 3 } }}>
            {/* Header Section */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: { xs: 2, md: 2.5 },
                pb: 2,
                borderBottom: '2px solid rgba(67, 56, 202, 0.1)',
                flexWrap: { xs: 'wrap', sm: 'nowrap' },
                gap: { xs: 1.5, sm: 2 },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box
                  sx={{
                    width: { xs: '36px', md: '40px' },
                    height: { xs: '36px', md: '40px' },
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'linear-gradient(135deg, rgba(67, 56, 202, 0.15) 0%, rgba(99, 102, 241, 0.15) 100%)',
                    color: '#4338ca',
                    flexShrink: 0,
                  }}
                >
                  <AttachMoney sx={{ fontSize: { xs: 20, md: 22 } }} />
                </Box>
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      color: '#1e293b',
                      fontSize: { xs: '18px', md: '20px' },
                      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                      letterSpacing: '-0.01em',
                      mb: 0.5,
                    }}
                  >
                    Payment and Discount
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      color: '#64748b',
                      fontSize: '12px',
                      fontStyle: 'italic',
                      display: { xs: 'none', sm: 'block' },
                    }}
                  >
                    Manage session fees and apply discounts (Not visible in Rx)
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <CancelAndRedoComponent
                  showCancel={hasPaymentData}
                  cancelClickFunction={() => {
                    keepSectionStateBeforeClearAll('payment_and_refund', {
                      choseToGiveDiscount,
                      discountedPriceOfSession,
                    })
                    setChoseToGiveDiscount(false)
                    setDiscountedPriceOfSession('')
                  }}
                  redoClickFunction={() =>
                    undoClearAllChangeInPrescription('payment_and_refund', (data) => {
                      if (data?.choseToGiveDiscount !== undefined) {
                        setChoseToGiveDiscount(data.choseToGiveDiscount)
                      }
                      if (data?.discountedPriceOfSession !== undefined) {
                        setDiscountedPriceOfSession(data.discountedPriceOfSession)
                      }
                    })
                  }
                />
                <SectionPrintIndicator 
                  sectionId="payment_and_refund" 
                  emrSectionsToShowInOrder={emrSectionsToShowInOrder}
                />
              </Box>
            </Box>

            {/* Payment Content Section */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {/* Fee Paid Display */}
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                <Typography
                  sx={{
                    fontWeight: 600,
                    color: '#475569',
                    fontSize: '15px',
                  }}
                >
                  Fee Paid:
                </Typography>
                <Typography
                  sx={{
                    fontWeight: 700,
                    color: '#1e293b',
                    fontSize: '16px',
                  }}
                >
                  {getPriceStringWithCurrency(bookedEventInfo?.feePaid, bookedEventInfo?.currency)}
                </Typography>
                {!choseToGiveDiscount && (
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => setChoseToGiveDiscount(true)}
                    sx={{
                      textTransform: 'none',
                      fontSize: '13px',
                      borderColor: 'rgba(67, 56, 202, 0.3)',
                      color: '#4338ca',
                      '&:hover': {
                        borderColor: 'rgba(67, 56, 202, 0.5)',
                        backgroundColor: 'rgba(67, 56, 202, 0.04)',
                      },
                    }}
                  >
                    Update Price
                  </Button>
                )}
              </Box>

              {/* Discount Input Section */}
              {choseToGiveDiscount && (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    flexWrap: { xs: 'wrap', sm: 'nowrap' },
                    p: 2,
                    backgroundColor: 'rgba(67, 56, 202, 0.03)',
                    borderRadius: '8px',
                    border: '1px solid rgba(67, 56, 202, 0.1)',
                  }}
                >
                  <Typography
                    sx={{
                      fontWeight: 600,
                      color: '#475569',
                      fontSize: '14px',
                      minWidth: '100px',
                    }}
                  >
                    Updated Price:
                  </Typography>
                  <PMPSectionInputBox
                    type="number"
                    style={{ 
                      width: '120px',
                      padding: '8px 12px',
                      borderRadius: '6px',
                    }}
                    value={discountedPriceOfSession}
                    onChange={(e) => setDiscountedPriceOfSession(e.target.value)}
                    disabled={!!bookedEventInfo?.discountAction?.discountedPrice}
                  />
                  {!bookedEventInfo?.discountAction?.discountedPrice && (
                    <Button
                      variant="contained"
                      size="small"
                      onClick={updateFinalPrice}
                      disabled={priceUpdateLoading}
                      sx={{
                        textTransform: 'none',
                        fontSize: '13px',
                        background: 'linear-gradient(135deg, rgba(67, 56, 202, 0.9) 0%, rgba(99, 102, 241, 0.9) 100%)',
                        '&:hover': {
                          background: 'linear-gradient(135deg, rgba(67, 56, 202, 1) 0%, rgba(99, 102, 241, 1) 100%)',
                        },
                        minWidth: '100px',
                      }}
                    >
                      {priceUpdateLoading ? (
                        <CircularProgress size={16} sx={{ color: '#fff' }} />
                      ) : (
                        'Confirm'
                      )}
                    </Button>
                  )}
                  {bookedEventInfo?.discountAction?.discountedPrice && (
                    <Typography
                      variant="caption"
                      sx={{
                        color: '#10b981',
                        fontSize: '12px',
                        fontStyle: 'italic',
                      }}
                    >
                      ✓ Discount applied
                    </Typography>
                  )}
                </Box>
              )}
            </Box>
          </CardContent>
        </Card>
      )
    }

    function renderPrivateNotesSection() {
      return (
        <PrivateNotesSection
          ref={notesRef}
          patientName={prescriptionData?.patientPrefill?.name}
          thisBookedEventId={bookedEventInfo?.id}
          patientId={bookedEventInfo?.patientId}
        />
      )
    }

    function renderReferToSection() {
      const section = emrSectionsToShowInOrder?.find((item) => item?.id === 'refer_to')
      const hasReferToData = referredToDoctorName && referredToDoctorName.trim().length > 0
      
      return (
        <Card
          sx={{
            mb: 3,
            maxWidth: '1200px',
            width: '100%',
            background: 'linear-gradient(135deg, rgba(250, 250, 255, 0.98) 0%, rgba(255, 255, 255, 0.98) 100%)',
            border: '1px solid rgba(67, 56, 202, 0.12)',
            borderRadius: '16px',
            boxShadow: '0 4px 20px rgba(67, 56, 202, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05)',
            overflow: 'visible',
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '4px',
              background: 'linear-gradient(90deg, rgba(67, 56, 202, 0.8) 0%, rgba(99, 102, 241, 0.8) 100%)',
              borderRadius: '16px 16px 0 0',
            },
          }}
          className={section?.printable ? '' : 'hide-on-print'}
        >
          <CardContent sx={{ p: { xs: 2, sm: 2.5, md: 3 } }}>
            {/* Header Section */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: { xs: 2, md: 2.5 },
                pb: 2,
                borderBottom: '2px solid rgba(67, 56, 202, 0.1)',
                flexWrap: { xs: 'wrap', sm: 'nowrap' },
                gap: { xs: 1.5, sm: 2 },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box
                  sx={{
                    width: { xs: '36px', md: '40px' },
                    height: { xs: '36px', md: '40px' },
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'linear-gradient(135deg, rgba(67, 56, 202, 0.15) 0%, rgba(99, 102, 241, 0.15) 100%)',
                    color: '#4338ca',
                    flexShrink: 0,
                  }}
                >
                  <BadgeIcon sx={{ fontSize: { xs: 20, md: 22 } }} />
                </Box>
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      color: '#1e293b',
                      fontSize: { xs: '18px', md: '20px' },
                      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                      letterSpacing: '-0.01em',
                      mb: 0.5,
                    }}
                  >
                    Referred To
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      color: '#64748b',
                      fontSize: '12px',
                      fontStyle: 'italic',
                      display: { xs: 'none', sm: 'block' },
                    }}
                  >
                    Refer patient to another doctor or specialist
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <CancelAndRedoComponent
                  showCancel={hasReferToData}
                  cancelClickFunction={() => {
                    keepSectionStateBeforeClearAll('refer_to', referredToDoctorName)
                    setReferredToDoctorName('')
                  }}
                  redoClickFunction={() =>
                    undoClearAllChangeInPrescription('refer_to', (data) => {
                      if (typeof data === 'string') {
                        setReferredToDoctorName(data)
                      }
                    })
                  }
                />
                <SectionPrintIndicator 
                  sectionId="refer_to" 
                  emrSectionsToShowInOrder={emrSectionsToShowInOrder}
                />
              </Box>
            </Box>

            {/* Content Section */}
            <Box>
              <TextareaAutosize
                placeholder="Doctor Name / Speciality / Contact"
                className="pmpTextarea-focus pmp-rounded-box"
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid rgba(67, 56, 202, 0.2)',
                  background: '#fff',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                  minHeight: '80px',
                }}
                value={referredToDoctorName}
                onChange={(e) => {
                  setReferredToDoctorName(e.target.value)
                }}
              />
            </Box>
          </CardContent>
        </Card>
      )
    }

    function renderTherapyRecommendationSection() {
      const section = emrSectionsToShowInOrder?.find((item) => item?.id === 'therapy_recommendation')
      const hasTherapyData = Array.isArray(selectedTherapies) && selectedTherapies?.length > 0
      
      return (
        <Card
          data-section-id="therapy_recommendation"
          sx={{
            mb: 3,
            maxWidth: '1200px',
            width: '100%',
            background: 'linear-gradient(135deg, rgba(250, 250, 255, 0.98) 0%, rgba(255, 255, 255, 0.98) 100%)',
            border: '1px solid rgba(67, 56, 202, 0.12)',
            borderRadius: '16px',
            boxShadow: '0 4px 20px rgba(67, 56, 202, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05)',
            overflow: 'visible',
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '4px',
              background: 'linear-gradient(90deg, rgba(67, 56, 202, 0.8) 0%, rgba(99, 102, 241, 0.8) 100%)',
              borderRadius: '16px 16px 0 0',
            },
          }}
          className={section?.printable ? '' : 'hide-on-print'}
        >
          <CardContent sx={{ p: { xs: 2, sm: 2.5, md: 3 } }}>
            {/* Header Section */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: { xs: 2, md: 2.5 },
                pb: 2,
                borderBottom: '2px solid rgba(67, 56, 202, 0.1)',
                flexWrap: { xs: 'wrap', sm: 'nowrap' },
                gap: { xs: 1.5, sm: 2 },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box
                  sx={{
                    width: { xs: '36px', md: '40px' },
                    height: { xs: '36px', md: '40px' },
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'linear-gradient(135deg, rgba(67, 56, 202, 0.15) 0%, rgba(99, 102, 241, 0.15) 100%)',
                    color: '#4338ca',
                    flexShrink: 0,
                  }}
                >
                  <Psychology sx={{ fontSize: { xs: 20, md: 22 } }} />
                </Box>
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      color: '#1e293b',
                      fontSize: { xs: '18px', md: '20px' },
                      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                      letterSpacing: '-0.01em',
                      mb: 0.5,
                    }}
                  >
                    Refer for Therapy
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      color: '#64748b',
                      fontSize: '12px',
                      fontStyle: 'italic',
                      display: { xs: 'none', sm: 'block' },
                    }}
                  >
                    Recommend therapy sessions for patient
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <CancelAndRedoComponent
                  showCancel={hasTherapyData}
                  cancelClickFunction={() => {
                    keepSectionStateBeforeClearAll('therapy_recommendation', selectedTherapies)
                    setSelectedTherapies([])
                  }}
                  redoClickFunction={() =>
                    undoClearAllChangeInPrescription('therapy_recommendation', (data) =>
                      setSelectedTherapies(data),
                    )
                  }
                />
                <SectionPrintIndicator 
                  sectionId="therapy_recommendation" 
                  emrSectionsToShowInOrder={emrSectionsToShowInOrder}
                />
              </Box>
            </Box>

            {/* Content Section */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>

                {/* Dropdown */}
                <Box>
              <SuggestedTherapySelectMenu
                selectedTherapies={selectedTherapies}
                setSelectedTherapies={setSelectedTherapies}
              />
                </Box>

                {/* Placeholder for popular therapies pills (future feature) */}
                {/* <Box sx={{ mt: 1 }}>
                  <Typography sx={{ fontSize: '12px', color: '#6b7280', mb: 1, fontWeight: 600 }}>
                    Popular Therapies for this Diagnosis:
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                    Popular therapy pills will appear here
                  </Box>
                </Box> */}

                {/* Attach Prescription Checkbox */}
            {selectedTherapies?.length > 0 && (
              <FormControlLabel
                    sx={{ width: 'fit-content', mt: 1 }}
                control={
                  <Checkbox
                    checked={attachPrescriptionForTherapy}
                    onChange={(e) => {
                      setAttachPrescriptionForTherapy(e.target.checked)
                    }}
                        sx={{
                          color: '#6366f1',
                          '&.Mui-checked': {
                            color: '#6366f1',
                          },
                    }}
                  />
                }
                    label={
                      <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
                        Attach Prescription for Therapy
                      </Typography>
                    }
                  />
                )}

                {/* Notes Section */}
            {suggestedBookingTherapy && (
                  <Box sx={{ mt: 1 }}>
                    <Typography
                      sx={{
                        fontSize: '14px',
                        fontWeight: 600,
                        color: '#374151',
                        mb: 1,
                        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                      }}
                    >
                      Notes to Psychologist for Therapy
                    </Typography>
                  <TextareaAutosize
                    placeholder="Enter notes that you want to send to the psychologists who will take this case..."
                    className="pmpTextarea-focus pmp-rounded-box"
                    style={{
                      width: '100%',
                        padding: '12px',
                        border: '1px solid rgba(99, 102, 241, 0.3)',
                      background: '#fff',
                        borderRadius: '8px',
                        fontSize: '14px',
                        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                    }}
                    value={notesToTherapist}
                    onChange={(e) => {
                      setNotesToTherapist(e.target.value)
                    }}
                  />
                  </Box>
            )}
            </Box>
          </CardContent>
        </Card>
      )
    }

    function renderPsychAssessmentSelection() {
      const section = emrSectionsToShowInOrder?.find((item) => item?.id === 'psych_assessments')
      const hasAssessmentData = Array.isArray(selectedAssessments) && selectedAssessments?.length > 0
      
      return (
        <Card
          data-section-id="psych_assessments"
          sx={{
            mb: 3,
            maxWidth: '1200px',
            width: '100%',
            background: 'linear-gradient(135deg, rgba(250, 250, 255, 0.98) 0%, rgba(255, 255, 255, 0.98) 100%)',
            border: '1px solid rgba(67, 56, 202, 0.12)',
            borderRadius: '16px',
            boxShadow: '0 4px 20px rgba(67, 56, 202, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05)',
            overflow: 'visible',
            position: 'relative',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: '4px',
              background: 'linear-gradient(90deg, rgba(67, 56, 202, 0.8) 0%, rgba(99, 102, 241, 0.8) 100%)',
              borderRadius: '16px 16px 0 0',
            },
          }}
          className={section?.printable ? '' : 'hide-on-print'}
        >
          <CardContent sx={{ p: { xs: 2, sm: 2.5, md: 3 } }}>
            {/* Header Section */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                mb: { xs: 2, md: 2.5 },
                pb: 2,
                borderBottom: '2px solid rgba(67, 56, 202, 0.1)',
                flexWrap: { xs: 'wrap', sm: 'nowrap' },
                gap: { xs: 1.5, sm: 2 },
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                <Box
                  sx={{
                    width: { xs: '36px', md: '40px' },
                    height: { xs: '36px', md: '40px' },
                    borderRadius: '10px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'linear-gradient(135deg, rgba(67, 56, 202, 0.15) 0%, rgba(99, 102, 241, 0.15) 100%)',
                    color: '#4338ca',
                    flexShrink: 0,
                  }}
                >
                  <Assignment sx={{ fontSize: { xs: 20, md: 22 } }} />
                </Box>
                <Box>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 700,
                      color: '#1e293b',
                      fontSize: { xs: '18px', md: '20px' },
                      fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                      letterSpacing: '-0.01em',
                      mb: 0.5,
                    }}
                  >
                    Refer for Assessment
                  </Typography>
                  <Typography
                    variant="caption"
                    sx={{
                      color: '#64748b',
                      fontSize: '12px',
                      fontStyle: 'italic',
                      display: { xs: 'none', sm: 'block' },
                    }}
                  >
                    Recommend psychological assessments for patient
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <CancelAndRedoComponent
                  showCancel={hasAssessmentData}
                  cancelClickFunction={() => {
                    keepSectionStateBeforeClearAll('assessments', selectedAssessments)
                    setSelectedAssessments([])
                  }}
                  redoClickFunction={() =>
                    undoClearAllChangeInPrescription('assessments', (data) =>
                      setSelectedAssessments(data),
                    )
                  }
                />
                <SectionPrintIndicator 
                  sectionId="psych_assessments" 
                  emrSectionsToShowInOrder={emrSectionsToShowInOrder}
                />
              </Box>
            </Box>

            {/* Content Section */}
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>

              {/* Dropdown */}
              <Box>
            <SuggestedAssessmentsSelectMenu
              selectedAssessments={selectedAssessments}
              setSelectedAssessments={setSelectedAssessments}
              doctorSpecializations={mentorProfileData?.specializedCategories}
            />
              </Box>

              {/* Placeholder for popular assessments pills (future feature) */}
              {/* <Box sx={{ mt: 1 }}>
                <Typography sx={{ fontSize: '12px', color: '#6b7280', mb: 1, fontWeight: 600 }}>
                  Popular Assessments for this Diagnosis:
                </Typography>
                <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                  Popular assessment pills will appear here
                </Box>
              </Box> */}

              {/* Attach Prescription Checkbox */}
          {selectedAssessments?.length > 0 && (
            <>
              <FormControlLabel
                    sx={{ width: 'fit-content', mt: 1 }}
                control={
                  <Checkbox
                    checked={attachPrescriptionForAssessments}
                    onChange={(e) => {
                      setAttachPrescriptionForAssessments(e.target.checked)
                    }}
                        sx={{
                          color: '#6366f1',
                          '&.Mui-checked': {
                            color: '#6366f1',
                          },
                        }}
                      />
                    }
                    label={
                      <Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
                        Attach Prescription for Assessments
                      </Typography>
                    }
                  />
                  <Box sx={{ mt: 1 }}>
                    <Typography
                      sx={{
                        fontSize: '14px',
                        fontWeight: 600,
                        color: '#374151',
                        mb: 1,
                        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                      }}
                    >
                      Notes for Assessments
                    </Typography>
                  <TextareaAutosize
                      placeholder="Enter notes that you want to send to the psychologists who will take the assessment..."
                    className="pmpTextarea-focus pmp-rounded-box"
                    style={{
                      width: '100%',
                        padding: '12px',
                        border: '1px solid rgba(99, 102, 241, 0.3)',
                      background: '#fff',
                        borderRadius: '8px',
                        fontSize: '14px',
                        fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
                    }}
                    value={notesForAssessments}
                    onChange={(e) => {
                      setNotesForAssessments(e.target.value)
                    }}
                  />
                  </Box>
            </>
          )}
            </Box>
          </CardContent>
        </Card>
      )
    }

    function renderSectionForDoconLayout(leftComponentEmrItem, rightComponentEmrItem) {
      if (!leftComponentEmrItem) {
        return (
          <DoconPageItemsContainer singleItem>
            <DoconPageSingleItemContainer>
              {renderSectionForDocon(leftComponentEmrItem?.id, 0)}
            </DoconPageSingleItemContainer>
          </DoconPageItemsContainer>
        )
      }
      if (!rightComponentEmrItem) {
        return (
          <DoconPageItemsContainer singleItem>
            <DoconPageSingleItemContainer>
              {renderSectionForDocon(leftComponentEmrItem?.id, 0)}
            </DoconPageSingleItemContainer>
          </DoconPageItemsContainer>
        )
      }
      return (
        <DoconPageItemsContainer>
          <DoconPageSingleItemContainer
            style={{ borderRight: '1px solid #0000004a', paddingRight: '26px' }}
          >
            {renderSectionForDocon(leftComponentEmrItem?.id, 0)}
          </DoconPageSingleItemContainer>
          <DoconPageSingleItemContainer style={{ paddingLeft: '26px' }}>
            {renderSectionForDocon(rightComponentEmrItem?.id, 1)}
          </DoconPageSingleItemContainer>
        </DoconPageItemsContainer>
      )
    }

  return {
    nextVisitDetailsSection,
    renderSignatureSection,
    renderPatientVitals,
    renderObservations,
    renderHealthComplaints,
    renderDiagnosis,
    renderJointHomunculus,
    renderDrugAdvice,
    renderInvestigations,
    renderAdvice,
    renderInstructions,
    renderPayemntAndRefundSection,
    renderPrivateNotesSection,
    renderReferToSection,
    renderTherapyRecommendationSection,
    renderPsychAssessmentSelection,
    renderSectionForDoconLayout,
  }
}
